import { Link } from "react-router-dom";
import { MapPin, ImageOff, BadgeCheck, Gift, Rocket } from "lucide-react";
import DemoRibbon from "@/components/DemoRibbon";
import LikeButton from "@/components/LikeButton";
import ShareButton from "@/components/ShareButton";

const API = process.env.REACT_APP_BACKEND_URL;

export const AnnonceCard = ({ a, testIdPrefix = "annonce" }) => {
  const dt = a.published_at || a.created_at;
  const boosted = a.boosted_until && a.boosted_until > new Date().toISOString();
  return (
    <Link
      to={`/petites-annonces/annonce/${a.slug}`}
      data-testid={`${testIdPrefix}-card-${a.id}`}
      className="group block bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-[#E05638] hover:shadow-md transition-all duration-200"
    >
      <div className="aspect-[4/3] bg-slate-100 relative overflow-hidden">
        {a.main_image ? (
          <img src={a.main_image} alt={a.title} loading="lazy"
               className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
        ) : (
          <div className="w-full h-full grid place-items-center text-slate-300">
            <ImageOff size={34} />
            <span className="sr-only">Aucune photo</span>
          </div>
        )}
        {a.price_type === "free" && (
          <span className="absolute top-2 left-2 inline-flex items-center gap-1 bg-emerald-600 text-white text-[11px] font-bold px-2 py-0.5 rounded-full">
            <Gift size={11} /> Gratuit
          </span>
        )}
        {boosted && (
          <span className="absolute top-2 left-2 inline-flex items-center gap-1 bg-amber-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ marginTop: a.price_type === "free" ? "1.75rem" : 0 }} data-testid={`${testIdPrefix}-boosted-${a.id}`}>
            <Rocket size={10} /> À la une
          </span>
        )}
        {a.is_pro && (
          <span className="absolute top-2 right-2 inline-flex items-center gap-1 bg-slate-900/85 text-white text-[10px] font-semibold px-2 py-0.5 rounded-full">
            <BadgeCheck size={11} /> Pro
          </span>
        )}
        {a.image_count > 1 && (
          <span className="absolute bottom-2 right-2 bg-black/60 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded">
            {a.image_count} photos
          </span>
        )}
        {a.demo && <DemoRibbon />}
      </div>
      <div className="p-3">
        <div className="font-semibold text-slate-900 text-sm line-clamp-2 min-h-[2.5rem]">{a.title}</div>
        <div className="mt-1.5 font-heading font-extrabold text-[#E05638]">
          {a.price_type === "free" ? "Gratuit" : a.price_label}
        </div>
        <div className="mt-1 flex items-center justify-between text-xs text-slate-500">
          <span className="inline-flex items-center gap-1 truncate"><MapPin size={11} /> {a.city}{a.distance != null ? ` · ${a.distance} km` : ""}</span>
          {dt && <span className="shrink-0">{new Date(dt).toLocaleDateString("fr-FR")}</span>}
        </div>
        <div className="mt-2 pt-2 border-t border-slate-100 flex items-center justify-between">
          <LikeButton type="annonce" id={a.id} liked={a.liked} count={a.likes} variant="icon" testId={`${testIdPrefix}-like-${a.id}`} />
          <ShareButton url={`${API}/api/annonce-vitrine/${a.slug}`} title={a.title} text={`${a.price_label} · ${a.title} — à ${a.city}`} variant="icon" testId={`${testIdPrefix}-share-${a.id}`} />
        </div>
      </div>
    </Link>
  );
};

export default AnnonceCard;
